import { render, staticRenderFns } from "./BecomeCoach.vue?vue&type=template&id=1430fb32"
import script from "./BecomeCoach.vue?vue&type=script&lang=js"
export * from "./BecomeCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports